import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

import type { AutoSuggestProps } from './index';

export const S = {
  Wrapper: styled.div<Pick<AutoSuggestProps, 'inlineCss'>>`
    position: relative;
    ${({ theme }) => theme.media.mobile} {
      width: 100%;
    }
    ${({ inlineCss }) => inlineCss};
  `,
  CompanyListWrapper: styled.div<Pick<AutoSuggestProps, 'listCss'>>`
    position: absolute;
    text-align: left;
    width: 100%;
    margin-top: 8px;
    border: 1px solid ${({ theme }) => theme.colors.gray600};
    border-radius: 4px;
    left: 0;

    background-color: ${({ theme }) => theme.colors.white100};
    box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 1001;

    ${({ listCss }) => listCss};
  `,
  CompanyListTitle: styled.div`
    color: ${({ theme }) => theme.colors.gray700};
    padding: 12px 16px;
  `,
  CompanyList: styled.ul`
    margin-right: 4px;
    overflow-y: auto;
    height: 187px;

    &::-webkit-scrollbar {
      width: 5px;
      height: 8px;
      margin-right: 4px;
      background-color: ${({ theme }) => theme.colors.gray400};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.colors.magenta700};
    }
  `,
  CompanyInfo: styled.li`
    ${getFontStyle('midium150_B3')};
    cursor: pointer;
    padding: 4px 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    strong {
      color: ${({ theme }) => theme.colors.magenta700};
    }

    span {
      color: ${({ theme }) => theme.colors.gray800};
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.gray300};
    }

    &:nth-child(-1) {
      padding-bottom: 8px;
    }
  `,
};
